import React, { useEffect, useRef } from "react";
import OverviewItem from "./OverviewItem";
import { useLocation } from "react-router-dom";
import clsx from "clsx";

const blocksData = [
  {
    date: "2 сентября",
    time: "13:00",
    tags: ["турпродукт", "задержка рейсов"],
    title:
      "Новые правила игры для турагентов: все что нужно знать этой осенью, чтобы не попасть на штрафы",
    speaker: {
      name: "Екатерина Голубева",
      photo: null,
      position: "юрист-партнер ЮА “Персона Грата”",
    },
  },
  {
    date: "4 сентября",
    time: "12:00",
    tags: ["реклама", "посты"],
    title:
      "Нельзяграм и туристическая компания: где и как теперь турагенту можно рекламироваться, а где — опасно",
    speaker: {
      name: "Максим Ковалевский",
      photo: "Kovalevski.png",
      position: "юрист компании «Юристы для турбизнеса Байбородин и партнёры»",
    },
  },
  {
    date: "9 сентября",
    time: "13:00",
    tags: ["WA", "TG", "личные данные"],
    title:
      "WhatsApp, Telegram и другие мессенджеры: где будем общаться с клиентами",
    speaker: {
      name: "Мария Чапиковская",
      photo: "Chapikovskaya.png",
      position: "юрист Альянса туристических агентств (АТА)",
    },
  },
  {
    date: "11 сентября",
    time: "13:00",
    tags: ["ИИ", "контент"],
    title:
      "Нейросети и соцсети: как турагенту создавать контент без судебных проблем",
    speaker: {
      name: "Ольга Коханюк",
      photo: "Kohanuk.png",
      position: "юрист и стратег в IT и туристической отрасли",
    },
  },
];

const Overview = (): JSX.Element => {
  const location = useLocation();
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const anchor = new URLSearchParams(location.search).get("anchor");
    if (anchor === "about" && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location, ref]);

  return (
    <section
      id="about"
      ref={ref}
      className="bg-white py-14 md:py-16 lg:py-[100px] 2xl:py-[120px] 3xl:py-[140px]"
    >
      <div
        className={clsx(
          "cont flex flex-col gap-10 xl:gap-16 2xl:gap-[60px] 3xl:gap-20"
        )}
      >
        <div className="flex flex-col gap-6">
          <p className="title-middle">
            Онлайн-практикум <br className="hidden md:block xl:hidden" /> для
            турагентов
          </p>
          <p className="leading-[130%] lg:text-18 lg:leading-[125%] xl:text-24 font-light">
            Всё, что нужно знать турагенту с{" "}
            <span className="text-red-500">1 сентября 2025 года</span> в России
            в связи <br className="hidden lg:block xl:hidden" /> с новым{" "}
            <br className="hidden xl:block" /> законодательством о рекламе,
            мессенджерах и личных данных.
          </p>
        </div>

        <div className={clsx("grid gap-5", "md:gap-8", "lg:grid-cols-2")}>
          {blocksData.map((item, index) => (
            <OverviewItem
              key={index}
              title={item.title && item.title}
              date={item.date}
              time={item.time}
              tags={item.tags}
              speakerName={item.speaker.name}
              speakerPosition={item.speaker.position}
              speakerPhoto={
                item.speaker.photo
                  ? require(`@public/images/overview/${item.speaker.photo}`)
                  : require(`@public/images/default_avatar.png`)
              }
              isTopRow={index < 2}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Overview;
